import script from "./CardStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CardStatus.vue?vue&type=script&setup=true&lang=js"

import "./CardStatus.vue?vue&type=style&index=0&id=2161001a&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2161001a"]])

export default __exports__